import { ReactComponent as AmenityQRProd } from 'assets/amenity-qr-code-prod.svg';
import { ReactComponent as AmenityQRDevelopment } from 'assets/amenity-qr-code.svg';

import { AmenityData } from 'api/get-amenities';

import * as S from './amenity-header.styled';
import { formatTimeRange, getAmenityImageLink } from '../utils';
import { AMENITY_URL } from './constants';

const isDevelopment = process.env.NODE_ENV === 'development';

interface AmenityHeaderProps {
  amenity: AmenityData;
}

export const AmenityHeader = ({ amenity }: AmenityHeaderProps) => {
  const QrCode = isDevelopment ? AmenityQRDevelopment : AmenityQRProd;
  return (
    <S.Wrapper>
      <div className="image-wrapper">
        <img src={getAmenityImageLink(amenity.image)} alt={amenity.name} />
      </div>
      <div className="content">
        <div className="title-wrapper">
          <div className="title">{amenity.name}</div>
          <div>
            <div className="working-hours">Working hours</div>
            {formatTimeRange(amenity.availableStartTime, amenity.availableEndTime)}
          </div>
        </div>
        <span>Reserve amenities via the community app</span>
        <a href={AMENITY_URL} className="qr-code-wrapper" target="_blank" rel="noopener noreferrer">
          <QrCode />
        </a>
      </div>
    </S.Wrapper>
  );
};
